import './VideoTile.scss'

import classNames from 'classnames'
import SubscribeDialog from 'lib/components/SubscribeDialog/SubscribeDialog'
import AdminContext from 'lib/context/AdminContext'
import AuthContext from 'lib/context/AuthContext'
import { events, track } from 'lib/util/analytics'
import buildImagesUrl, { ImageSize } from 'lib/util/buildImagesUrl'
import formatTime from 'lib/util/formatTime'
import { preserveScrollAndNavigate } from 'lib/util/scrollBehavior'
import { videoUrl } from 'lib/util/urls'
import VideoType from 'pages/Home/VideoType'
import React, { MouseEvent, useContext, useRef, useState } from 'react'
import Dotdotdot from 'react-dotdotdot'
import { Link, useHistory } from 'react-router-dom'

import VideoTileAdminControls from './admin/VideoTileAdminControls'

export interface VideoTileProps {
  video: VideoType
}

export default function VideoTile(props: VideoTileProps): JSX.Element {
  const { video } = props
  const { name, id, published, rise, storyline, upload } = video

  const { getAccessToken } = useContext(AuthContext)
  const { showAdminControls } = useContext(AdminContext)
  const history = useHistory()
  const [isSubscribeDialogOpen, setIsSubscribeDialogOpen] = useState(false)
  const videoTileEl = useRef(null)

  const pathname = videoUrl(video)

  function onClick(e: MouseEvent) {
    track(
      events.videoClicked,
      {
        videoId: id,
        title: name,
        rise,
        storyline
      },
      getAccessToken,
      showAdminControls
    )

    if (e.ctrlKey || e.metaKey || e.shiftKey) {
      // don't interfere with "special" clicks
      return
    }

    e.preventDefault()

    preserveScrollAndNavigate(history, { pathname }, videoTileEl)
  }

  const className = classNames('video-tile-container', {
    'video-tile-container--unpublished': !published
  })
  const backgroundImageUrl = buildImagesUrl({
    videoUpload: video.upload,
    thumbnailUrlOverride: video.thumbnailKey,
    size: ImageSize.small
  })

  return (
    <div className={className} id={`video-${id}`} ref={videoTileEl}>
      <Link to={{ pathname }} onClick={onClick} title={name}>
        <div className="video-tile">
          <div className="video-tile__thumbnail" style={{ backgroundImage: `url(${backgroundImageUrl})` }}>
            {upload && upload.duration && (
              <div className="video-tile__thumbnail__duration">{formatTime((upload && upload.duration) || 0)}</div>
            )}
          </div>
          <div className="video-tile__display-name">
            <Dotdotdot clamp={2}>{name}</Dotdotdot>
          </div>
        </div>
      </Link>
      {showAdminControls && <VideoTileAdminControls video={video} />}
      {isSubscribeDialogOpen && <SubscribeDialog onRequestClose={() => setIsSubscribeDialogOpen(false)} />}
    </div>
  )
}
